import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { connect, Dispatch } from 'react-redux';
import { ICenterBillingRecord, IInvoiceCreditPaymentsReport } from '@nkr/models/index';
import { OrganType } from '@nkr/enums/index';
import { downloadFile } from '@nkr/services/download-file';
import { IApplicationState, AppActionCreators, BillingActionCreators, IBillingCenterReportResponse, IInvoiceCreditPaymentsResponse, ReportActionCreators, InvoicingActionCreators } from '@nkr/store/index';
import { ColumnApi, GridApi, GridReadyEvent, ProcessCellForExportParams, ExcelExportParams } from 'ag-grid-community';
import { Button, ButtonToolbar, ToggleButtonGroup, ToggleButton, FormControl, Well } from 'react-bootstrap';
import Grid from './grid';

interface IOwnProps {
    centerId: number,
    centerAlias: string
}

interface IStateProps {
    organType: OrganType
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getInvoiceCreditPaymentsReport: (centerId: number, startDate: string, endDate: string, organType: OrganType | null) => Promise<IInvoiceCreditPaymentsResponse>,
    getAccountsReceivableList: (organType: OrganType, receivableCenterId?: number, payableCenterId?: number) => Promise<IBillingCenterReportResponse>,
    getAccountsReceivableOpoList: (receivableCenterId?: number) => Promise<IBillingCenterReportResponse>,
    viewInvoice: (invoiceNumber: number) => Promise<any>;
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    payableList: IInvoiceCreditPaymentsReport[],
    receivableList: ICenterBillingRecord[],
    radioFilter: number,
    invoiceStartDate: string,
    invoiceEndDate: string,
    centerId: number,
    filteredCCBReceivableList: ICenterBillingRecord[],
    filteredOpoReceivableList: ICenterBillingRecord[],
    filteredPaymentList: IInvoiceCreditPaymentsReport[],
    useFilter: boolean,
    payableType: string,   // new
    organTypeFilter: string // new
}

interface IClearState {
    radioFilter: number,
    invoiceStartDate: string,
    invoiceEndDate: string,
    payableType: string,    // new
    organTypeFilter: string // new
}

const initialClearState: IClearState = {
    radioFilter: 1,
    invoiceStartDate: moment().subtract(12, 'months').startOf('month').format('YYYY-MM-DD'),
    invoiceEndDate: moment().format('YYYY-MM-DD'),
    payableType: '',    // new - empty means "All"
    organTypeFilter: '' // new - empty means "All"
}

const initialState: IState = {
    ...initialClearState,
    payableList: [],
    receivableList: [],
    centerId: 0,
    filteredCCBReceivableList: [],
    filteredOpoReceivableList: [],
    filteredPaymentList: [],
    useFilter: false
}

class AccountsTotalStatement extends React.Component<TProps, {}> {
    readonly state = initialState;

    gridApi: GridApi = null;
    gridColumnApi: ColumnApi = null;
    receivableGridApi: GridApi = null;
    receivableGridColumnApi: ColumnApi = null;

    onReceivableGridReady = (e: GridReadyEvent) => {
        this.receivableGridApi = e.api;
        this.receivableGridColumnApi = e.columnApi;
    }

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.gridColumnApi = e.columnApi;

        e.columnApi.applyColumnState({
            state: [
                { colId: 'centerHasLatePaymentsInLastYear', sort: 'asc' }
            ]
        });
    }

    componentDidMount = () => {
        this.getData();
    }



    getData = () => {
        this.props.showLoading('Searching, one moment please..').then(() => {
            Promise.all([
                this.props.getInvoiceCreditPaymentsReport(this.props.centerId, this.state.invoiceStartDate, this.state.invoiceEndDate, this.props.organType),
                this.props.getAccountsReceivableList(this.props.organType, this.props.centerId, null),
                this.props.getAccountsReceivableOpoList(this.props.centerId)
            ])
                .then(([listPaymentResponse, receivableResponse, opoResponse]) => {
                    if (listPaymentResponse.data.success && receivableResponse.data.success && opoResponse.data.success) {

                        let listPayment = listPaymentResponse.data.results;
                        let listCCBReceivable = receivableResponse.data.results;
                        let listOpoReceivable = opoResponse.data.results;

                        var filteredCCBReceivableList = listCCBReceivable.filter(x => x.isPaid == false);
                        var filteredOpoReceivableList = listOpoReceivable.filter(x => x.isPaid == false);
                        var filteredPaymentList = listPayment.filter(x => x.amountRemaining > 0);

                        this.setState({
                            payableList: listPaymentResponse.data.results,
                            receivableList: receivableResponse.data.results,
                            filteredCCBReceivableList,
                            filteredOpoReceivableList,
                            filteredPaymentList
                        }, () => {
                            this.props.hideLoading();
                        });
                    } else {
                        this.props.hideLoading();
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    };


    handleRadioFilterChange = (radioType: number) => {
        this.setState({ radioFilter: radioType }, () => {
            this.handleFilteredData();
        });
    }

    handleDateChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;
        this.setState({ [name]: value });
    }

    // new
    handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { name, value } = e.currentTarget;
        this.setState({ [name]: value } as any);
    }

    handleFilteredData = () => {
        const paidInvoices = [0].includes(this.state.radioFilter);
        const openInvoicePayable = [1].includes(this.state.radioFilter);

        var filteredList = _.cloneDeep(this.state.payableList);

        if (paidInvoices) {
            filteredList = filteredList.filter(x => {
                const startDate = moment(this.state.invoiceStartDate);
                const endDate = moment(this.state.invoiceEndDate);
                const invoiceDate = moment({ year: x.invoiceYear, month: x.invoiceMonth - 1, day: 1 });
                const isPaid = x.amountPaid > 0;
                return invoiceDate.isSameOrAfter(startDate, 'month') && invoiceDate.isSameOrBefore(endDate, 'month') && isPaid;
            });
        } else if (openInvoicePayable) {
            filteredList = filteredList.filter(x => x.amountRemaining > 0);
        }

        this.setState({ useFilter: true, filteredList });
    }


    viewInvoice = (invoiceNumber) => {
        this.props.showLoading("Downloading Invoice").then(() => {
            this.props.viewInvoice(invoiceNumber).then((response: any) => {
                downloadFile(response.data, `invoice-${invoiceNumber}.pdf`, 'application/pdf');

                this.props.hideLoading();
            })
        })
    };


    getSheetParams = (columnApi: ColumnApi, sheetName: string): ExcelExportParams => {
        return {
            columnGroups: true,
            sheetName: sheetName,
            columnKeys: columnApi.getAllColumns().map(x => x.getColId()),
            // ag-grid takes pixels and converts with ceil((px - 12) / 7 + 1); 200px yields an excel width of 28
            columnWidth: 200,
            processCellCallback: (params: ProcessCellForExportParams) => {
                if (params.column.getColId() == 'organType') {
                    return params.value == null ? '--' : params.value == OrganType.Liver ? 'L' : 'K';
                }

                return params.value;
            },
        };
    }

    handleExport = () => {
        let sheets = [
            this.gridApi.getSheetDataForExcel(this.getSheetParams(this.gridColumnApi, 'Invoices Payable'))
        ];

        if (this.receivableGridApi != null) {
            sheets.push(this.receivableGridApi.getSheetDataForExcel(this.getSheetParams(this.receivableGridColumnApi, 'Accounts Receivable')));
        }

        this.gridApi.exportMultipleSheetsAsExcel({
            fileName: `accounts-total-statement.xlsx`,
            data: sheets
        });
    }

    handleClear = () => {
        this.setState(initialClearState, () => {
            this.handleFilteredData();
        });
    }



    render = () => {
        const filteredCCBReceivableData = this.state.filteredCCBReceivableList.length > 0 || this.state.useFilter
            ? this.state.filteredCCBReceivableList
            : [];

        const filteredOpoReceivableData = this.state.filteredOpoReceivableList.length > 0 || this.state.useFilter
            ? this.state.filteredOpoReceivableList
            : [];

        const filteredPaymentData = this.state.filteredPaymentList.length > 0 || this.state.useFilter
            ? this.state.filteredPaymentList
            : [];

        const showDateFilter = [0].includes(this.state.radioFilter);

        return (
            <>
                <div className='container-fluid'>
                    <div style={{ padding: 10, borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#ddd', borderBottomLeftRadius: 4, borderBottomRightRadius: 4 }}>
                        <Well bsSize='sm' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10 }}>

                                {/* Existing radio filter */}
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                    <div style={{ marginRight: 5, color: 'white', backgroundColor: '#143264', padding: '4px 8px' }}>Statement Of Open Accounts</div>

                                </div>


                                {showDateFilter && (
                                    <>
                                        <div style={{ display: 'flex', alignItems: 'center', marginLeft: 50, marginRight: 10 }}>  {/* <-- added marginLeft */}
                                            <div style={{ marginRight: 5, whiteSpace: 'nowrap' }}>Invoice Start Date:</div>
                                            <FormControl
                                                type='date'
                                                name='invoiceStartDate'
                                                value={this.state.invoiceStartDate}
                                                onChange={this.handleDateChange}
                                            />
                                        </div>

                                        <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                            <div style={{ marginRight: 5, whiteSpace: 'nowrap' }}>Invoice End Date:</div>
                                            <FormControl
                                                type='date'
                                                name='invoiceEndDate'
                                                value={this.state.invoiceEndDate}
                                                onChange={this.handleDateChange}
                                            />
                                        </div>

                                        <div>
                                            <Button bsStyle={'primary'} onClick={this.handleFilteredData}>Search</Button>
                                        </div>
                                    </>
                                )}
                            </div>

                            <div style={{ display: 'flex', marginLeft: '50px' }}>
                                <Button onClick={this.handleClear} style={{ marginRight: 5 }}>Clear</Button>
                                <Button bsStyle={'success'} onClick={this.handleExport}>Export to Excel</Button>
                            </div>
                        </Well>

                        <Grid dataPayment={filteredPaymentData} dataCCBReceivable={filteredCCBReceivableData} dataOpoReceivable={filteredOpoReceivableData} centerId={this.props.centerId} organType={this.props.organType} onViewClicked={this.viewInvoice} onGridReady={this.onGridReady} onReceivableGridReady={this.onReceivableGridReady} />
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        organType: appState.app.site.organType
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => dispatch(AppActionCreators.showLoadingAsync(message)),
        hideLoading: () => dispatch(AppActionCreators.hideLoading()),
        getInvoiceCreditPaymentsReport: (payableCenterId, startDate, endDate, organType) => {
            return dispatch(ReportActionCreators.getInvoiceCreditPaymentsReport(payableCenterId, startDate, endDate, organType));
        },
        getAccountsReceivableList: (organType, receivableCenterId, payableCenterId) => {
            return dispatch(BillingActionCreators.getCenterBillingByList(organType, receivableCenterId, payableCenterId));
        },
        getAccountsReceivableOpoList: (receivableCenterId) => {
            return dispatch(BillingActionCreators.getCenterBillingAccountsReceivableOpoList(receivableCenterId));
        },
        viewInvoice: (invoiceNumber) => {
            return dispatch(InvoicingActionCreators.viewInvoice(invoiceNumber));
        }

    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(AccountsTotalStatement);